import { StyleObject } from "styletron-react";

/**
 * Styles to hide a label visually but ensure it
 * is still available for accessibility purposes
 */
export const hideLabelStyles = (): StyleObject => ({
  transform: "translate(-10000%,-10000%)",
  position: "absolute",
});
